export const JOB_INVOCATIONS_POLLING_STARTED =
  'JOB_INVOCATIONS_POLLING_STARTED';
export const JOB_INVOCATIONS_GET_JOB_INVOCATIONS =
  'JOB_INVOCATIONS_GET_JOB_INVOCATIONS';
export const JOB_INVOCATIONS_JOB_FINISHED = 'JOB_INVOCATIONS_JOB_FINISHED';



// WEBPACK FOOTER //
// /builddir/build/BUILDROOT/rubygem-foreman_remote_execution-8.0.0-2.fm3_4.el8.noarch/usr/share/gems/gems/foreman_remote_execution-8.0.0/webpack/react_app/redux/consts.js